import { resolveSequencesConfigPageVisible } from "@swivl-mono/helpers";

import AccountModel from "../../Models/Account/AccountModel";

/**
 * Is the Property Manager v3 Sequences tab (and its routes) visible to the current
 * account on the current org? The `sequences_page` flag plus the engine switches
 * (ENG-3542) — see `resolveSequencesConfigPageVisible`. Same snapshot read as
 * `isFeatureEnabled`.
 */
export function isSequencesConfigPageVisible(): boolean {
  const { account, member } = AccountModel.state;
  return resolveSequencesConfigPageVisible(account, member?.org);
}
